import React, { useEffect, useState } from 'react';
import { firestore } from "../../firebase-config";
import { collection, getDocs } from "firebase/firestore";
import '../../styles/publication.css'; // Import the CSS file

const PublicationList = () => {
  const [publications, setPublications] = useState([]);

  useEffect(() => {
    const fetchPublications = async () => {
      const publicationsRef = collection(firestore, 'publications');
      const querySnapshot = await getDocs(publicationsRef);
      const docs = querySnapshot.docs.map((doc) => doc.data());
      setPublications(docs);
    };

    fetchPublications();
  }, []);

  return (
    <div className="publication-container">
      <h2>OUR PUBLICATIONS</h2>
      {publications.length === 0 ? (
        <p>No publications available.</p>
      ) : (
        <div className="publication-grid">
          {publications.map((pub, index) => (
            <div key={index} className="publication-item">
              <div>
                <strong>{pub.name}</strong>
              </div>
              <div>
                {/* PDF inline viewer */}
                {pub.type === 'application/pdf' && (
                  <iframe
                    src={pub.url}
                    title={pub.name}
                    className="publication-iframe"
                    style={{ border: 'none' }}
                  />
                )}

                {/* Buttons container */}
                <div style={{ marginTop: '10px' }}>
                  {/* Open file in new tab */}
                  <a
                    href={pub.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="open-button"
                    style={{
                      marginRight: '10px',
                      padding: '8px 15px',
                      backgroundColor: '#004d80',
                      color: 'white',
                      borderRadius: '5px',
                      textDecoration: 'none',
                      fontWeight: 'bold',
                    }}
                  >
                    Open File
                  </a>

                  {/* Download button */}
                  <a
                    href={pub.url}
                    download
                    className="download-button"
                    style={{
                      padding: '8px 15px',
                      backgroundColor: '#008000',
                      color: 'black',
                      borderRadius: '5px',
                      textDecoration: 'none',
                      fontWeight: 'bold',
                    }}
                  >
                    Download
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PublicationList;

